export default require('./Font').default
